import React, { useEffect, useState } from "react";
import AddAdvocatePopup from "../Component/AddAdvocatePopup";
import { API_BASE_URL } from "../config";


export default function Advocate() {
    const [advocate, setAdvocate] = useState([]);
    const [newAdvocate, setNewAdvocate] = useState({ courtName: "", location: "" });
    const [editingAdvocate, setEditingAdvocate] = useState(null);

    // Fetch all courts
      useEffect(() => {
        fetchAdcocate();
      }, []);

      const fetchAdcocate = async() =>{
        try{
            const token = localStorage.getItem("token");
            const res = await fetch("https://AdvocateAPI.codelovertechnology.com/api/AdvocateMaster/GetAdvocate", {
                headers: {Authorization: `Bearer ${token}`},
            });
            if(res.ok) {
                const data = await res.json();
                setAdvocate(data);                
            }
            else{
                console.error("Failed to fetch status");
            }
        }catch(err){
            console.error("Error:",err);
        }
      }

    // Add new advocate
    const handleAddAdvocate = async (newAdvocate) => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
    formData.append("BarCouncilNo", newAdvocate.BarCouncilNo);
    formData.append("Specialization", newAdvocate.Specialization);
    formData.append("Name", newAdvocate.Name);
    formData.append("Father_Name", newAdvocate.Father_Name);
    formData.append("Address", newAdvocate.Address);
    formData.append("Contact_No", newAdvocate.Contact_No);
    formData.append("Whatsapp_contact_no", newAdvocate.Whatsapp_contact_no);
    formData.append("Personal_emailid", newAdvocate.Personal_emailid);
    formData.append("Official_emailid", newAdvocate.Official_emailid);
    formData.append("Working_address", newAdvocate.Working_address);
    formData.append("Chamber_no", newAdvocate.Chamber_no);
    formData.append("Court_no", newAdvocate.Court_no);

    // If you have file input
    if (newAdvocate.Photo) {
      formData.append("Photo", newAdvocate.Photo);
    }


      const res = await fetch(`${API_BASE_URL}/api/AdvocateMaster/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      if (res.ok) {
        fetchAdcocate(); // Refresh list
        setNewAdvocate({ courtName: "", location: "" });
        alert("Advocate added successfully!");
      } else {
        console.error("Failed to add advocate");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  }; 

  // Delete court
  const handleDeleteAdvocate = async (id) => {
    if (!window.confirm("Are you sure you want to delete this advocate?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/Court/deletecourt/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setAdvocate((prev) => prev.filter((c) => c.id !== id));
        alert("Advocate deleted successfully!");
      } else {
        console.error("Failed to delete court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Update advocate
  const handleUpdateAdvocate = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/AdvocateMaster/update/${editingAdvocate.advocateId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingAdvocate),
      });
      if (res.ok) {
        fetchAdcocate();
        setEditingAdvocate(null);
        alert("Advocate updated successfully!");
      } else {
        console.error("Failed to update advocate");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
      <div style={{ padding: "20px" }}>
        <h2>Manage Advocate</h2>      
        <AddAdvocatePopup onAddAdvocate={handleAddAdvocate} />
  
        {/* Advocate Table */}
        <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>BarCouncil No</th>
              <th>Specialization</th>
              <th>Advocate Name</th>
              <th>Address</th>
              <th>Contact_No</th>                            
              <th>Official_emailid</th>
              <th>Photo</th>
              <th>Chamber_no</th>
              <th>CourtName</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {advocate.length > 0 ? (
              advocate.map((advocate) => (
                <tr key={advocate.advocateId}>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.barCouncilNo}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, barCouncilNo: e.target.value })
                        }
                      />
                    ) : (
                      advocate.barCouncilNo
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.specialization}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, specialization: e.target.value })
                        }
                      />
                    ) : (
                      advocate.specialization
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.name}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, name: e.target.value })
                        }
                      />
                    ) : (
                      advocate.name
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.address}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, address: e.target.value })
                        }
                      />
                    ) : (
                      advocate.address
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.contact_No}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, contact_No: e.target.value })
                        }
                      />
                    ) : (
                      advocate.contact_No
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.official_emailid}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, official_emailid: e.target.value })
                        }
                      />
                    ) : (
                      advocate.official_emailid
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.photo}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, photo: e.target.value })
                        }
                      />
                    ) : (
                      <img
                        src={`${API_BASE_URL}${advocate.photo}`} // prepend API base URL
                        alt="Advocate"
                        width="60"
                        height="80"
                        style={{ borderRadius: "8px", objectFit: "cover" }}
                     />
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.chamber_no}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, chamber_no: e.target.value })
                        }
                      />
                    ) : (
                      advocate.chamber_no
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <input
                        type="text"
                        value={editingAdvocate.courtName}
                        onChange={(e) =>
                          setEditingAdvocate({ ...editingAdvocate, courtName: e.target.value })
                        }
                      />
                    ) : (
                      advocate.courtName
                    )}
                  </td>
                  <td>
                    {editingAdvocate?.advocateId === advocate.advocateId ? (
                      <>
                        <button onClick={handleUpdateAdvocate}>Save</button>
                        <button onClick={() => setEditingAdvocate(null)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => setEditingAdvocate(advocate)}>Edit</button>
                        <button onClick={() => handleDeleteAdvocate(advocate.advocateId)}>Delete</button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10">No Advocate found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
}